import React from "react";
import { Star, Quotes } from "@phosphor-icons/react";
import Reveal from "./Reveal";
import { useLang } from "../context/LanguageContext";

export default function ReviewsSection({ reviews = [] }) {
  const { t, lang } = useLang();

  return (
    <section className="relative py-24 lg:py-40 bg-[#0c0c0e] hairline-top hairline-bottom" data-testid="reviews-section">
      <div className="container-x">
        <div className="max-w-3xl mb-14">
          <Reveal>
            <div className="overline mb-4">{t.reviews.overline}</div>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1]">
              {t.reviews.title.split("\n").map((l, i) => (
                <span key={l || `reviews-line-${i}`} className="block">{l}</span>
              ))}
            </h2>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {reviews.slice(0, 4).map((rv, i) => (
            <Reveal key={rv.id} delay={i * 0.08}>
              <figure className="border border-white/10 p-7 h-full flex flex-col bg-[#09090b]/50" data-testid={`review-${rv.id}`}>
                <Quotes size={28} weight="fill" className="text-[#C5A059]/60" />
                <blockquote className="mt-5 text-base font-serif italic leading-relaxed text-white/85 flex-1">
                  "{lang === "it" ? rv.text_it : rv.text_en}"
                </blockquote>
                <div className="flex items-center gap-1 mt-6 text-[#C5A059]">
                  {Array.from({ length: rv.rating }).map((_, k) => (
                    <Star key={`${rv.id}-star-${k}`} size={14} weight="fill" />
                  ))}
                </div>
                <figcaption className="mt-3 text-xs uppercase tracking-[0.15em] text-white/50">
                  {rv.guest_name} · {rv.nationality} · {rv.source}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
